import type { ReactNode } from "react";
import { ScreenHeader } from "../../../next/page/ScreenHeader";

type Props = {
  title: string;
  /** kept for callers; the new design takes the accent from the shell */
  accent?: string;
  sub?: ReactNode;
  actions?: ReactNode;
};

/** Team meetings screen header — the new-design page header with the screen's own actions. */
export function TeamMeetingsHeader({ title, sub, actions }: Props) {
  return (
    <ScreenHeader title={title} sub={sub ?? "הכנה, סדר יום, סיכום ומשימות המשך"}>
      {actions}
    </ScreenHeader>
  );
}
